import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import ErrorBoundary from "./components/ErrorBoundary"
import Header from "./components/Header";
import routes from "./routes";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
import FullScreenLoader from "./collections/shared/FullScreenLoader/FullScreenLoader";
import InsertNameScreen from "./screens/InsertNameScreen";
import * as Sentry from '@sentry/react';
import "./config/sentry.config";

const AuthenticatedRoute = ({ children }) => {
  const { access_token, has_name } = useSelector((state) => state.user);
  if (!access_token) {
    return <Navigate to="/" />;
  }
  if (!has_name || has_name === "false") {
    return <InsertNameScreen />;
  }
  return children;
};

export const createRoutes = (routes) =>
  routes.map((route) => (
    <Route
      key={route.path}
      path={route.path}
      element={
        route.auth ? (
          <AuthenticatedRoute>
            <route.component />
          </AuthenticatedRoute>
        ) : (
          <route.component />
        )
      }
    >
      {route.children ? createRoutes(route.children) : ""}
    </Route>
  ));

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 1,
      },
    },
  });
  return (
    <div className="App h-full">
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<FullScreenLoader />}>
          <BrowserRouter>
          <ErrorBoundary>
            <Header />
            <Routes>{createRoutes(routes)}</Routes>
          </ErrorBoundary>
          </BrowserRouter>
        </Suspense>
      </QueryClientProvider>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default Sentry.withProfiler(App);
